/**
 * Import vendor libraries for use.
 */
import Vue from 'vue';
import VueJSModal from "vue-js-modal";
import VueRouter from "vue-router";
import App from './../ts/quote/components/app';
import Selection from './../ts/quote/components/selection';
import SelectPlan from './../ts/quote/components/selectPlan';
import Checkout from './../ts/quote/components/checkout';
import Start from './../ts/quote/components/start';
import EvStart from './../ts/quote/components/ev/start';
import EvQuestions from './../ts/quote/components/ev/questions';
import EvSiteSurvey from './../ts/quote/components/ev/site-survey';
import EvQuote from './../ts/quote/components/ev/quote';
import store from "../ts/quote/store/store";
import VModal from 'vue-js-modal';

/* Custom Components */
import CategorySidebar from './woocommerce/components/CategorySidebar';
import FlipImageLinkCard from './components/FlipImageLinkCard';
import ReadMore from './components/ReadMore';

/* Load Quote page Vue app*/
if (document.getElementById('app-quote')) {
    /**
     * Load Vue App & required components
     */
    Vue.use(VueRouter);
    Vue.use(VueJSModal, {dialog: true});
    Vue.use(VModal);

    const router = new VueRouter({
        mode: 'history',
        routes: [
            {
                name: 'selection',
                path: '/quote',
                component: Selection,
                props: route => ({uuid: route.query.uuid}),
            },
            {
                name: 'select-plan',
                path: '/quote/select-plan',
                component: SelectPlan,
                props: route => ({uuid: route.query.uuid}),
            },
            {
                name: 'checkout',
                path: '/quote/checkout',
                component: Checkout,
                props: route => ({uuid: route.query.uuid}),
            },
            {
                name: 'start',
                path: '/quote/start',
                component: Start,
            },
            {
                name: 'ev-start',
                path: '/quote/ev-charging',
                component: EvStart,
            },
            {
                name: 'ev-questions',
                path: '/quote/ev-charging/questions',
                component: EvQuestions,
            },
            {
                name: 'ev-site-survey',
                path: '/quote/ev-charging/site-survey',
                component: EvSiteSurvey,
            },
            {
                name: 'ev-quote',
                path: '/quote/ev-charging/quote',
                component: EvQuote,
            },
            {
                name: 'quote-nursery',
                path: '/quote/nursery',
                component: Selection,
                props: {industry: 'nursery'},
            },
            {
                name: 'quote-nursery-start',
                path: '/quote/nursery/start',
                component: Start,
                props: {industry: 'nursery'},
            },
            {
                name: 'quote-dental',
                path: '/quote/dental',
                component: Selection,
                props: {industry: 'dental'},
            },
            {
                name: 'quote-dental-start',
                path: '/quote/dental/start',
                component: Start,
                props: {industry: 'dental'},
            },
            {
                name: 'quote-nursing-care-homes',
                path: '/quote/nursing-care-homes',
                component: Selection,
                props: {industry: 'nursing-care-homes'},
            },
            {
                name: 'quote-nursing-care-homes-start',
                path: '/quote/nursing-care-homes/start',
                component: Start,
                props: {industry: 'nursing-care-homes'},
            }
        ]
    });

    const app = new Vue({
        el: '#app-quote',
        router,
        store,
        render: h => h(App)
    });
}

/* Load CMS pages Vue app*/
if (document.getElementById('app-cms')) {
    const app = new Vue({
        el: '#app-cms',
        components: {
            'flip-image-link-card': FlipImageLinkCard,
            'read-more': ReadMore
        }
    });
}

if (document.getElementById('app-woocommerce')) {
    const app = new Vue({
        el: '#app-woocommerce',
        components: {
            'category-sidebar': CategorySidebar
        }
    });
}

/**
 * Load feather icons & trigger replace
 */
const feather = require('feather-icons');

feather.replace();
